import { index as dashboard } from "api/dashboard";
import { update, addProbateCase, emailOptOutPublic, emailOptOutSecure, getEmailOptOutsSecure } from "api/accounts";
import { createCallback, getRestrictions, cancelCallback } from "api/callback";
/* Wrapper for all ajax activity for Accounts data */
class AcctsRepository {
    /**
     * Get all account data from the server, before converting and wrapping it in a Promise
     *
     * @method getAll
     * @returns {axios.Promise}
     */
    getAll() {
        return dashboard().then(({ data }) => data);
    }
    /**
     * Sends request to update an account relationship
     *
     * @method updateRelationship
     * @param {Object} _data Data to send with request
     * @returns {axios.Promise}
     */
    updateRelationship(_data) {
        return update(_data).then(({ data }) => data);
    }
    createCallback(callback) {
        return createCallback(callback).then(({ data }) => data);
    }
    loadCallbackRestrictions() {
        return getRestrictions().then(({ data }) => data);
    }
    addProbateCase(payableId, probateCase) {
        return addProbateCase(payableId, probateCase).then(({ data }) => data);
    }
    cancelCallback(id) {
        return cancelCallback(id).then(({ data }) => data);
    }
    emailOptOutPublic(token) {
        return emailOptOutPublic(token ?? "").then(({ data }) => data);
    }
    emailOptOutSecure(refNums) {
        return emailOptOutSecure(refNums).then(({ data }) => data);
    }
    loadOptedOutEmailRefNums() {
        return getEmailOptOutsSecure().then(({ data }) => data);
    }
}
export default new AcctsRepository();



// WEBPACK FOOTER //
// ./src/assets/scripts/domain/accts/AcctsRepository.ts